export type BrandingApiResponse = {
  logo?: string
  iconLogo?: string
  brandName?: string
  name?: string
  "app-general-overlay"?: string
  "app-org-chart-bg"?: string
  "primary-color"?: string
  "secondary-color"?: string
  "overlay-top-stop"?: string
  "overlay-bottom-stop"?: string
}

export type PracticeSettings = {
  logo?: string
  iconLogo?: string
  name: string
  brandName: string
  appGeneralOverlay?: string
  appOrgChartBg?: string
  primaryColor?: string
  secondaryColor?: string
  overlayTopStop?: string
  overlayBottomStop?: string
}

const HSL_COMPONENT_REGEX = /^\d+deg \d+% \d+%$/
const HSL_FULL_REGEX = /^hsl\((\d+deg \d+% \d+%)\)$/

const DEFAULT_OVERLAY_TOP_STOP = "#ffffffb3"
const DEFAULT_OVERLAY_BOTTOM_STOP = "#f3f6f4"

const normalizeHslComponents = (color?: string): string | undefined => {
  if (!color) return undefined
  if (HSL_COMPONENT_REGEX.test(color)) return color

  const match = color.match(HSL_FULL_REGEX)
  if (match) return match[1]

  return undefined
}

const mapBrandingResponse = (raw: BrandingApiResponse): PracticeSettings => ({
  logo: raw.logo,
  iconLogo: raw.iconLogo,
  name: raw.name ?? "",
  brandName: raw.brandName ?? "",
  appGeneralOverlay: raw["app-general-overlay"],
  appOrgChartBg: raw["app-org-chart-bg"],
  primaryColor: normalizeHslComponents(raw["primary-color"]),
  secondaryColor: normalizeHslComponents(raw["secondary-color"]),
  overlayTopStop: raw["overlay-top-stop"] ?? DEFAULT_OVERLAY_TOP_STOP,
  overlayBottomStop: raw["overlay-bottom-stop"] ?? DEFAULT_OVERLAY_BOTTOM_STOP,
})

export { mapBrandingResponse, DEFAULT_OVERLAY_TOP_STOP, DEFAULT_OVERLAY_BOTTOM_STOP, normalizeHslComponents }
